export const NOT_DIGIT_OR_DOT_REGEX = /[^\d.]/g;
